<template>
  <a-button type="default" v-bind="$attrs" @click="showModal">
    批量导入
  </a-button>
  <a-modal
    v-model:visible="visible"
    width="650px"
    title="提示"
    ok-text="提交"
    cancel-text="取消"
    :mask-closable="false"
    :ok-button-props="{ disabled: fileList.length === 0 }"
    :confirm-loading="confirmLoading"
    @ok="handleOk"
  >
    <div class="container">
      <div class="upload-wrap">
        <h2>如需批量导入，请上传文件：</h2>
        <a-upload
          v-model:file-list="fileList"
          name="file"
          :multiple="false"
          :before-upload="beforeUpload"
          :show-upload-list="false"
          customRequest="handleChange"
          accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
        >
          <a-button>
            <upload-outlined />
            上传文件
          </a-button>
        </a-upload>
      </div>
      <div class="tips-wrap">
        <span class="tips-wrap-span">上传时请使用我们提供的格式文件</span>
        <span class="tips-wrap-div-accect">支持：xls\xlsx\csv文件</span>
      </div>
      <div class="down-template">
        <a :href="templateURI" download="多语言.xlsx">下载模板</a>
      </div>
    </div>
  </a-modal>
</template>

<script>
import { defineComponent, reactive, toRaw, toRefs } from 'vue'
import { UploadOutlined } from '@ant-design/icons-vue'
import { message } from 'ant-design-vue'
import { formRequest } from 'cupshe-axios'

export default defineComponent({
  components: { UploadOutlined },
  setup() {
    const state = reactive({
      path: '',
      fileList: [],
      confirmLoading: false,
      visible: false,
      uploadAction: process.env.VUE_APP_CMCADMIN + '/product/modifyBatch',
      showModal: () => {
        state.visible = true
        state.fileList = []
      },

      handleOk: () => {
        state.confirmLoading = true
        formRequest(
          state.uploadAction,
          {
            skcExcel: toRaw(state.fileList)[0].originFileObj
          },
          {
            timeout: 60000,
            Headers: { Authorization: localStorage.getItem('token') }
          }
        )
          .then(res => {
            if (res.success) {
              state.visible = false
              message.success('上传成功', 2)
            } else {
              message.error(res.retInfo)
            }

            state.confirmLoading = false
          })
          .catch(err => {
            console.log(err)
            state.confirmLoading = false
          })
      },
      getSuffix: str => {
        const fileExtension = str.substring(str.lastIndexOf('.') + 1)
        return fileExtension
      },
      beforeUpload(file) {
        const suffix = state.getSuffix(file.name)
        const isExcelType =
          suffix === 'xlsx' || suffix === 'xls' || suffix === 'csv'
        if (!isExcelType) {
          return Promise.reject(
            message.error('请上传 xlsx | xls | csv 格式文件 !')
          )
        }
        const isLt20M = file.size / 1024 / 1024 < 20
        if (!isLt20M) {
          return Promise.reject(message.error('上传文件不能大于20M !'))
        }
        return Promise.reject()
      },
      handleChange: file => {
        console.log('handleChange', file)
        if (file.fileList.length === 2) {
          state.fileList = state.fileList.splice(1, 1)
        }
      },
      onRemove: () => {
        state.fileList = state.fileList.splice(1, 1)
      },
      onSubmit: () => {
        state.visible = false
        state.visible2 = false
      },
      templateURI:
        'https://cupshe-cdn.oss-cn-hangzhou.aliyuncs.com/web/CMC/Multi-language.xlsx'
    })

    return {
      ...toRefs(state)
    }
  }
})
</script>

<style lang="scss" scoped>
.container {
  .upload-wrap {
    display: flex;
    justify-content: space-between;
    align-content: center;
    margin-bottom: 10px;
    h2 {
      font-size: 16px;
    }
  }
  .tips-wrap {
    &-span {
      font-size: 12px;
    }
    &-div {
      display: flex;
      justify-content: space-between;
      align-content: center;
      margin-top: 5px;
      p {
        color: red;
      }
      &-accect {
        color: #9a9a9a;
      }
    }
  }
  .down-template {
    margin-top: 10px;
    a {
      color: blue;
    }
  }
}
.agc {
  align-content: center;
}
.ellipsis {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box; //作为弹性伸缩盒子模型显示。
  -webkit-box-orient: vertical; //设置伸缩盒子的子元素排列方式--从上到下垂直排列
  -webkit-line-clamp: 1; //显示的行
  padding-right: 50px;
}
.single-ul {
  margin-top: 18px;
  white-space: pre;
  max-height: 500px;
  overflow: auto;
  li {
    line-height: 2;
    span {
      display: inline-block;
      // width: 140px;
    }
  }
}

.wrapper {
  overflow: auto;
}
.f05 {
  flex: 0.5;
}
.f2 {
  flex: 2;
}
</style>
